// UC14 Phase 5.3: 2 action goi proxy qlvb-be, dung boi StepUpOtpModal.vue (khong dung boi component nao khac).
import { callApiStepUpChallenge, callApiStepUpVerify } from "@/api/step-up";

const getStepUpChallenge = (_, payload) => {
  return new Promise((resolve, reject) => {
    callApiStepUpChallenge(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const verifyStepUpOtp = (_, payload) => {
  return new Promise((resolve, reject) => {
    callApiStepUpVerify(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  getStepUpChallenge,
  verifyStepUpOtp,
};
